import moment from 'moment'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  namespaced: true,
  state: {
    categoryPortals: null,
    affichageReduit: false,
    devise: '',
    contactsDateBefore: moment().subtract(7, 'days'),
    contactsDateAfter: moment()
  },
  mutations: {
    SET_CATEGORY_PORTALS (state, categoryPortals) {
      state.categoryPortals = categoryPortals
    },
    SET_AFFICHAGE_REDUIT (state, affichageReduit) {
      state.affichageReduit = affichageReduit
    },
    SET_DEVISE (state, devise) {
      state.devise = devise
    },
    SET_CONTACTS_DATE_BEFORE (state, contactsDateBefore) {
      state.contactsDateBefore = contactsDateBefore
    },
    SET_CONTACTS_DATE_AFTER (state, contactsDateAfter) {
      state.contactsDateAfter = contactsDateAfter
    }
  },
  getters: {
    getCategoryPortals: (state) => {
      return state.categoryPortals
    },
    getAffichageReduit: (state) => {
      return state.affichageReduit
    },
    getDevise: (state) => {
      return state.devise
    },
    getContactsDateBefore: (state) => {
      return state.contactsDateBefore
    },
    getContactsDateAfter: (state) => {
      return state.contactsDateAfter
    }
  },
  actions: {
    loadCategories ({ commit }) {
      HTTP_HYPER_ESPACE_BACKEND.get('/v2/categories')
        .then(response => {
          // console.log(response.data)
          commit('SET_CATEGORY_PORTALS', response.data)
        }).catch(error => {
          console.log({ type: 'error', message: error })
        })
    }
  }
}
